import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { WaziWordmark } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock, Mail, AlertCircle } from "lucide-react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@wazi.chat");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("wazi_token", res.data.access_token);
      localStorage.setItem("wazi_admin", JSON.stringify(res.data.user));
      navigate("/admin");
    } catch (e) {
      setErr("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7FAFC] flex flex-col items-center justify-center p-4">
      <Link to="/" className="mb-8" data-testid="login-logo-link"><WaziWordmark size={36} /></Link>
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl p-8 shadow-sm" data-testid="admin-login-form">
        <h1 className="font-heading text-2xl font-bold text-[#2D3748]">Admin sign in</h1>
        <p className="mt-1 text-sm text-[#718096]">Manage workers, leads, quotes, and reviews.</p>
        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email" className="text-[#2D3748] font-heading font-medium">Email</Label>
            <div className="relative mt-1.5">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#718096]" />
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-9 h-11 rounded-xl border-[#E2E8F0] focus:border-[#25D366] focus:ring-[#25D366]"
                required
              />
            </div>
          </div>
          <div>
            <Label htmlFor="password" className="text-[#2D3748] font-heading font-medium">Password</Label>
            <div className="relative mt-1.5">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#718096]" />
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-9 h-11 rounded-xl border-[#E2E8F0] focus:border-[#25D366] focus:ring-[#25D366]"
                required
              />
            </div>
          </div>
          {err && (
            <div className="flex items-center gap-2 text-[#DC2626] text-sm bg-[#DC2626]/5 border border-[#DC2626]/20 rounded-lg px-3 py-2" data-testid="login-error">
              <AlertCircle className="w-4 h-4" /> {err}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full h-11 rounded-xl bg-[#25D366] hover:bg-[#16A34A] text-white font-medium wazi-cta-glow"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <div className="text-center">
            <a
              href="mailto:hello@wazi.chat?subject=Password%20reset%20request&body=Hi%20Wazi%20team%2C%0A%0AI%20need%20to%20reset%20my%20admin%20password%20for%20%5Bemail%5D.%0A%0AThanks."
              data-testid="forgot-password-link"
              className="text-sm text-[#1E88E5] hover:text-[#1565C0] hover:underline font-medium"
            >
              Forgot password?
            </a>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
